<template>
  <div>
    <!-- <transition :name="transition_name" :css="true"> -->
    <!-- <keep-alive> -->
    <router-view></router-view>
    <!-- </keep-alive> -->
    <!-- </transition> -->
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      chooseLang: "CN"
    };
  },
  created() {


    if (this.utils.getCookie("lang")) {
      this.chooseLang = this.utils.getCookie("lang");
    }
    this.getCategories();
    this.getProducts();
    this.getWebsiteVideoCategories();
  },
  mounted: function () { },
  beforeDestroy: function () {
    document.body.removeAttribute("class", "add_bg");
  },
  methods: {
    getCategories() {
      if (this.chooseLang === "CN") {
        let params = {};
        this.req
          .get(
            url_api_web_websiteProductCategory_getWebsiteProductCategories,
            this.qs.stringify(params)
          )
          .then(result => {
            localStorage.setItem(
              "product_categories",
              JSON.stringify(result.website_product_categories)
            );
          })
          .catch(error => { });
      } else if (this.chooseLang === "EN") {
        let params = {};
        this.req
          .get(
            url_api_web_websiteProductCategory_getWebsiteProductCategories,
            this.qs.stringify(params)
          )
          .then(result => {
            localStorage.setItem(
              "product_categories-en",
              JSON.stringify(result.website_product_categories)
            );
          })
          .catch(error => { });
      }
    },
    getProducts() {
      if (this.chooseLang === "CN") {
        let params = {};
        this.req
          .get(
            url_api_web_websiteProduct_getNavWebsiteProducts,
            this.qs.stringify(params)
          )
          .then(result => {
            localStorage.setItem(
              "product_nav",
              JSON.stringify(result.website_products)
            );
          })
          .catch(error => { });
      } else if (this.chooseLang === "EN") {
        let params = {};
        this.req
          .get(
            url_api_web_websiteProduct_getNavWebsiteProducts,
            this.qs.stringify(params)
          )
          .then(result => {
            localStorage.setItem(
              "product_nav-en",
              JSON.stringify(result.website_products)
            );
          })
          .catch(error => { });
      }
    },
    getWebsiteVideoCategories() {
      if (this.chooseLang === "CN") {
        let params = {};
        this.req
          .get(
            url_api_web_websiteVideoCategory_getWebsiteVideoCategories,
            this.qs.stringify(params)
          )
          .then(result => {
            localStorage.setItem(
              "video_categories",
              JSON.stringify(result.website_video_categories)
            );
          })
          .catch(error => { });
      } else if (this.chooseLang === "EN") {
        let params = {};
        this.req
          .get(
            url_api_web_websiteVideoCategory_getWebsiteVideoCategories,
            this.qs.stringify(params)
          )
          .then(result => {
            localStorage.setItem(
              "video_categories-en",
              JSON.stringify(result.website_video_categories)
            );
          })
          .catch(error => { });
      }
    }
  }
};
</script>

<style>
.add_bg {
  margin: 0;
  padding: 0;
}
</style>
